import React from "react";
import { Outlet, Link } from "react-router-dom";
// import { Link } from "@chakra-ui/react";
import {
  Stack,
  Center,
  ButtonGroup,
  Heading,
  Button,
  Box,
  Flex,
  Text,
  useColorModeValue,
  Spacer,
  Image
} from "@chakra-ui/react";

import { selectUser,login, signupUser } from "../reducers/userSlice"
import { useAppSelector, useAppDispatch } from '../hooks'
import LoginButtons from "../components/loginButtons";
import VMConnectHandler from "../components/connectHandler";


function SettingsButton() {
  const user = useAppSelector(selectUser);
  if (user.loggedIn === true && user.username != "admin"){
  return (
    <>
      <Link to="/settingsPage">
        <Button
          fontSize={"lg"}
          fontWeight={600}
          color={"white"}
          bg={"#211a52"}
        >
          The Box
        </Button>
      </Link>
    </>
  )
  }
  else {
    return (
    <>
      
        <Button
          fontSize={"lg"}
          fontWeight={600}
          color={"white"}
          bg={"gray.500"}
        >
          The Box
        </Button>
    </>
  )
  }
}

function AdminButton(){
  const user = useAppSelector(selectUser);
  console.log(String(user.username))
  if ( user.username === "admin"){
      return (
        <>
        <Link to="/admin">
        <Button
          fontSize={"lg"}
          fontWeight={600}
          color={"white"}
          bg={"#211a52"}
        >
          Admin Page
        </Button>
      </Link>
      </>
      )
    
  }
  else {
    return (
      <>
      
      </>
    )
  }

}

export default function Navbar() {

  return (
    <>
      <nav>
        <Flex
          // bg={useColorModeValue("white", "gray.800")}
          color={useColorModeValue("blue.100", "white")}
          minH={"60px"}
          py={{ base: 4 }}
          px={{ base: 4 }}
          minWidth="max-content"
          alignItems="center"
          gap="5"
        >
          <Box>
          <Link to="/">
          <Image src="logo_nav.svg" h="100px" />
          </Link>
          </Box>
          <ButtonGroup gap={3}>
            <Link to="/">
              <Button
                fontSize={"lg"}
                fontWeight={600}
                color={"white"}
                bg={"#211a52"}
              >
                Home
              </Button>
            </Link>
          <SettingsButton/>

            <AdminButton/>
            <VMConnectHandler/>
          </ButtonGroup>
          <Spacer/>
          <ButtonGroup gap={3}>
          <LoginButtons/>
          </ButtonGroup>
        </Flex>
      </nav>
      <Outlet />
    </>
  );
}
